import { ReportTemplateContextProvider } from "pages/reports/components/ReportTemplateContextProvider"
import React from "react"
import { Container } from "@mui/material"
import { ReportTypeEnum } from "pages/reports/interfaces/reports.interfaces"
import UpdateTemplateForm from "pages/reports/components/UpdateTemplateForm/UpdateTemplateForm"

const EditTemplate = ({ match }) => {
  return (
    <ReportTemplateContextProvider>
      <Container>
        <UpdateTemplateForm 
          match={match}
          reportType={ReportTypeEnum.Vehicle}
        />
      </Container>
    </ReportTemplateContextProvider>
  )
}

export default EditTemplate
